import { SelectItem } from 'app/components/SelectList';
import { Variable } from 'app/pages/Manage/Responses/renderers';
import { VariableType } from 'types/domain/variable';

export const Operators = [
  { name: '=', value: 0 },
  { name: '+', value: 1 },
  { name: '-', value: -1 },
] as SelectItem[];

export const VariableTypes = [
  { name: 'Pass/Fail', value: VariableType.BOOLEAN },
  { name: 'Score', value: VariableType.SCORE },
  { name: 'Option', value: VariableType.OPTIONS },
  { name: 'Attribute', value: VariableType.ATTRIBUTE },
] as SelectItem[];

export const VariableStrings = (type: VariableType) => {
  switch (type) {
    case VariableType.BOOLEAN:
      return 'Pass/Fail';
    case VariableType.SCORE:
      return 'Score';
    case VariableType.OPTIONS:
      return 'Option';
    case VariableType.ATTRIBUTE:
      return 'Attribute';
  }
};
